<template>
  <v-card style="height: 100%">
    <v-flex xs12 md12 style="height: 100%">
      <v-layout column style="height: 100%">
        <v-flex xs12 md12 style="height: 90vh; position: relative">
          <div class="scroll-wrapper">
            <div style="margin-left: 12px; margin-top: 6px; margin-right: 12px; margin-bottom: 6px; font-size: 12px;">
              <v-row justify="space-between">
                <p>Payable&nbsp;&nbsp;<b>£{{(totals.payable / 100).toFixed(2)}}</b></p>
                <p>Owe&nbsp;&nbsp;<b>£{{(totals.total_debt / 100).toFixed(2)}}</b></p>
                <p>Owed&nbsp;&nbsp;<b>£{{(totals.total_credit / 100).toFixed(2)}}</b></p>
                <p>Unpaid&nbsp;&nbsp;<b>{{totals.num_invoices}}</b></p>
              </v-row>
            </div>
             <v-flex pb-2 shrink>
              <v-row align="center">
                <v-flex pl-2 pb-1 shrink >
                  <v-text-field
                    style="width: 130px;"
                    dense
                    v-model="searchValues.query"
                    clearable
                    hide-details
                    label="Search"
                  />
                </v-flex>
                <v-flex pl-2 pb-1 shrink style="width: 120px">
                  <v-select
                    v-model="searchValues.filter"
                    :items="filters"
                    item-value="value"
                    item-text="name"
                    label="State"
                    dense
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex pl-2  shrink>
                <v-btn
                  small
                  outlined
                  white
                  class="text-none"
                  @click="searchDrivers()"
                >Search</v-btn>
                </v-flex>
                <v-flex pl-2 shrink>
                  <v-btn
                    small
                    outlined
                    white
                    class="text-none"
                    @click="transactions"
                  >Transactions</v-btn>
                </v-flex>
              </v-row>
            </v-flex>
            <v-expansion-panels :disabled="disabled" v-model="expanded">
              <v-expansion-panel
                v-for="(item, index) in invoicesSummary.drivers"
                :key="index"
              >
                <v-expansion-panel-header @click="getDriverInvoices(item)">
                  <v-row style="padding-right: 32px;">
                   <v-flex shrink>
                      <v-row>
                        <v-flex
                          style="padding-top: 6px; padding-right: 3px"
                        >
                          <img :src="item.driver.picture" style="height:36px; width: 36px; padding-right: 4px;" />
                        </v-flex>
                      </v-row>
                    </v-flex>
                    <v-col>
                      <v-flex style="font-size: 13px;" pb-1>
                        <v-row justify="space-between">
                          <v-flex shrink>
                            <v-row>
                              <v-flex
                                style="padding-top: 6px; padding-right: 3px"
                              >
                                <p>
                                  <b
                                    >{{ item.driver.callsign }}
                                    {{ item.driver.name }}</b
                                  >
                                </p>
                              </v-flex>
                              <v-flex shrink>
                                      <v-icon v-if="item.driver.has_card" color="green" small>mdi-credit-card-check-outline</v-icon>
                                  <v-icon small @click="goToDriver(item.driver.id)"
                                  >person</v-icon
                                >
                              </v-flex>
                            </v-row>
                          </v-flex>
                          <p
                            :class="
                              getDriverTotalInt(item.invoices, 'payable') < 0
                                ? 'red--text'
                                : 'green--text text--darken-2'
                            "
                            v-if="
                              !loadingSingleDriverSummary.state ||
                              loadingSingleDriverSummary.driverID !=
                                item.driver.id
                            "
                          >
                            <b>{{ getDriverTotal(item.invoices, "payable") }}</b>
                          </p>
                        </v-row>
                      </v-flex>
                      <v-flex style="font-size: 12px; color: grey">
                        <v-row justify="space-between">
                          <p>{{ item.invoices.length }} Invoices</p>
                          <p
                            v-if="
                              !loadingSingleDriverSummary.state ||
                              loadingSingleDriverSummary.driverID !=
                                item.driver.id
                            "
                          >
                            {{ getDateRange(item.invoices) }}
                          </p>
                        </v-row>
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="no-padding">
                  <v-flex v-if="loadingInvoicesForDriver" xs12 md12 pt-4 pb-4>
                    <v-layout align-center justify-center>
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        :size="70"
                      ></v-progress-circular>
                    </v-layout>
                  </v-flex>
                  <v-divider />
                  <v-list v-if="!loadingInvoicesForDriver" :elevation="0">
                    <v-list-item
                      v-for="invoice in invoicesDriver"
                      :key="invoice.id"
                      :style="calculateRowStyling(invoice)"
                    >
                      <v-list-item-content>
                        <v-col style="font-size: 12px">
                          <v-row style="padding-left: 6px; padding-right: 6px; padding-bottom: 6px;">
                            <v-flex pt-1>
                              <v-col justify="space-between">
                                <p>
                                  <b>{{ invoice.id }}</b>
                                </p>
                                <p>{{ getDate(invoice.date) }}</p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Cash</p>
                                <p>
                                  <b>{{
                                    formatMoneyValue(invoice.totals.cash)
                                  }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Card</p>
                                <p>
                                  <b>{{
                                    formatMoneyValue(invoice.totals.card)
                                  }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Acc
                                </p>
                                <p>
                                  <b>{{
                                    formatMoneyValue(invoice.totals.account)
                                  }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Fee</p>
                                <p>
                                  <b>{{
                                    formatMoneyValue(invoice.totals.serviceFee)
                                  }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Chg
                                </p>
                                <p>
                                  <b>{{
                                    formatMoneyValue(invoice.totals.charges)
                                  }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                             <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Payable
                                </p>
                                 <p
                                :class="
                                  getPayableColour(
                                    invoice.id,
                                    invoice.totals.payable
                                  )
                                "
                              >
                                <b>{{
                                  formatMoneyValue(invoice.totals.payable)
                                }}</b>
                              </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1>
                              <v-row>
                                <v-flex shrink pr-1><v-btn
                                color="blue"
                                dark
                                small
                                class="text-none"        
                                @click="loadInvoice(invoice.id, item.driver)"
                                ><p>View</p></v-btn></v-flex>
                              <v-btn
                                color="green lighten-5"
                                dark
                                small
                                class="text-none"
                                @click.stop="
                                  startClearInvoice(invoice, item.driver.id, item.driver.has_card)
                                "
                                ><p style="color: #2EBB84">PAY</p></v-btn>
                                </v-row>
                            </v-flex>
                          </v-row>
                         
                          <v-divider />
                        </v-col>
                      </v-list-item-content>
                    </v-list-item>
                     <v-list-item>
                      <v-list-item-content>
                        <v-col style="font-size: 12px">
                          <v-row style="padding-left: 6px; padding-right: 6px; padding-bottom: 6px;">
                            <v-flex pt-1>
                              <v-col justify="space-between">
                                <p v-html="getDateRange(item.invoices, true)"></p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Cash</p>
                                <p>
                                  <b>{{ getDriverTotal(item.invoices, "cash") }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Card</p>
                                <p>
                                   <b>{{ getDriverTotal(item.invoices, "card") }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Acc
                                </p>
                                <p>
                                   <b>{{ getDriverTotal(item.invoices, "account") }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">Fee</p>
                                <p>
                                   <b>{{ getDriverTotal(item.invoices, "serviceFee") }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                            <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Chg
                                </p>
                                <p>
                                    <b>{{ getDriverTotal(item.invoices, "charges") }}</b>
                                </p>
                              </v-col>
                            </v-flex>
                             <v-flex pt-1 pl-1>
                              <v-col>
                                <p style="font-size: 12px; color: grey">
                                  Payable
                                </p>
                                 <p
                                 :class="
                              getDriverTotalInt(item.invoices, 'payable') < 0
                                ? 'red--text'
                                : 'green--text text--darken-2'
                            "
                              >
                                <b>{{ getDriverTotal(item.invoices, "payable") }}</b>
                              </p>
                              </v-col>
                            </v-flex>
                             <v-flex pa-2 v-if="!loadingInvoicesForDriver" :elevation="0">
                            <v-btn
                              color="green lighten-5"
                              dark
                              small
                              class="text-none"
                              @click.stop="
                                startClearAccount(item.driver, item.invoices, item.driver.has_card)
                              "
                              ><p style="color: #2EBB84">Pay All</p></v-btn
                            >
                            </v-flex>
                          </v-row>
                         
                          <v-divider />
                        </v-col>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-flex>
        <v-layout xs12 md12 pt-1 pb-2>
          <v-row class="driverFooter">
            <v-flex xs6 md6 pb-2>
              <v-layout align-center justify-center row class="driverFooter">
                <v-btn text icon color="black" @click="pageDownDrivers()">
                  <v-icon>keyboard_arrow_left</v-icon>
                </v-btn>
                <v-btn text icon color="black" @click="pageUpDrivers()">
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
                <h5 class="nobold black--text text--darken-1">
                  Page {{ driverPagination.page }} of
                  {{ invoicesSummary.num_pages }}
                </h5>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 pr-1 style="padding-top: 9px">
              <v-layout align-center justify-end row>
                <h5
                  :class="
                    invoicesSummaryRows == 10
                      ? 'primary--text'
                      : 'nobold grey--text text--darken-1'
                  "
                  @click="$emit('changeSummaryRows', 10)"
                >
                  10 &nbsp
                </h5>
                <h5
                  :class="
                    invoicesSummaryRows == 25
                      ? 'primary--text'
                      : 'nobold grey--text text--darken-1'
                  "
                  @click="$emit('changeSummaryRows', 25)"
                >
                  25 &nbsp
                </h5>
                <h5
                  :class="
                    invoicesSummaryRows == 50
                      ? 'primary--text'
                      : 'nobold grey--text text--darken-1'
                  "
                  @click="$emit('changeSummaryRows', 50)"
                >
                  50 &nbsp
                </h5>
                <h5
                  :class="
                    invoicesSummaryRows == 100
                      ? 'primary--text'
                      : 'nobold grey--text text--darken-1'
                  "
                  @click="$emit('changeSummaryRows', 100)"
                >
                  100 &nbsp
                </h5>
              </v-layout>
            </v-flex>
          </v-row>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
import DateInputIcon from "@/components/widget/input/DateInputIcon.vue";

export default {
  name: "driver_list",
  components: {
    DateInputIcon,
  },
  props: {
    invoicesSummary: Object,
    invoicesDriver: Array,
    totals: Object,
    loadingPage: Boolean,
    loadingInvoicesForDriver: Boolean,
    loadingSingleDriverSummary: Object,
    invoicesSummaryRows: Number,
    disabled: Boolean,
    searchValues: Object
  },
  data: function () {
    return {
      expanded: [],
      selectedInvoiceID: -1,
      driverPagination: {
        descending: false,
        page: 1,
        rowsPerPage: this.invoicesSummaryRows,
        sortBy: null,
      },
      filters: [
        {
          id: 0,
          value: "",
          name: "All"
        },
        {
          id: 1,
          value: "onlyPayable",
          name: "Payable"
        },
        {
          id: 2,
          value: "onlyNotPayable",
          name: "Not Payable"
        },
      ],
      overallHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Outstanding Invoices",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Card",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Account",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Service Fees",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Charges",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Credits",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "Total Payable",
          align: "left",
          sortable: false,
          value: "duration",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "clear",
        },
      ],
      invoiceHeaders: [
        {
          text: "Invoice Reference",
          align: "left",
          sortable: false,
          value: "id",
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date",
        },
        {
          text: "Cash",
          align: "left",
          sortable: false,
          value: "totals.cash",
        },
        {
          text: "Card",
          align: "left",
          sortable: false,
          value: "totals.card",
        },
        {
          text: "Account",
          align: "left",
          sortable: false,
          value: "totals.account",
        },
        {
          text: "Service Fee",
          align: "left",
          sortable: false,
          value: "totals.serviceFee",
        },
        {
          text: "Charges",
          align: "left",
          sortable: false,
          value: "totals.charges",
        },
        {
          text: "Credits",
          align: "left",
          sortable: false,
          value: "totals.credits",
        },
        {
          text: "Extras",
          align: "left",
          sortable: false,
          value: "totals.extras",
        },
        {
          text: "Payable",
          align: "left",
          sortable: false,
          value: "totals.payable",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "clear",
        },
      ],
      formatter: Function,
    };
  },
  beforeMount: function () {
    this.formatter = new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  },
  methods: {
    transactions: function() {
      this.$router.push(`/transactions`);
    },
    collapse: function () {
      console.log("collapsing");
      this.expanded = [];
    },
    startClearAccount: function (driver, invoices, hasCard) {
      this.$emit("startClearAccount", driver, invoices, hasCard);
    },
    startClearInvoice: function (invoiceId, driverId, hasCard) {
      this.$emit("startClearInvoice", invoiceId, driverId, hasCard);
    },
    getDriverInvoices: function (driverTableProps) {
      for (var i = 0; i < this.invoicesSummary.drivers.length; i++) {
        if (
          this.invoicesSummary.drivers[i].driver.id !=
          driverTableProps.driver.id
        ) {
          this.invoicesSummary.drivers[i].expanded = false;
        }
      }

      console.log("Toggling invoices for driver " + driverTableProps.driver.id);
      driverTableProps.expanded = !driverTableProps.expanded;
      if (driverTableProps.expanded == true) {
        console.log(
          "trying to get driver invoices for driver " +
            driverTableProps.driver.id
        );
        this.$emit("getInvoicesSummaryDriver", driverTableProps.driver.id);
      }
    },
    getDate: function (date) {
      let parsedDate = new Date(date);
      let dd = parsedDate.getDate();
      let mm = parsedDate.getMonth() + 1;

      var yyyy = parsedDate.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let formattedDate = dd + "/" + mm + "/" + yyyy;

      return formattedDate;
    },
    getDateRange: function (invoices, breakline) {
      let start = new Date(invoices[0].date);
      let end = new Date(invoices[0].date);

      invoices.forEach(function (invoice) {
        let invoiceDate = new Date(invoice.date);
        if (invoiceDate < start) {
          start = invoiceDate;
        }
        if (invoiceDate > end) {
          end = invoiceDate;
        }
      });

      if (breakline != undefined) {
        return this.getDate(start) + "<br>" + this.getDate(end);
      } else {
        return this.getDate(start) + " - " + this.getDate(end);
      }
    },
    getDriverTotal: function (invoices, type) {
      let total = 0;
      invoices.forEach(function (invoice) {
        total += invoice.totals[type];
      });

      if (total == 0) {
        return "—";
      } else {
        return this.formatter.format(total / 100);
      }
    },
    getDriverTotalInt: function (invoices, type) {
      let total = 0;
      invoices.forEach(function (invoice) {
        total += invoice.totals[type];
      });

      return total;
    },
    formatMoneyValue: function (value) {
      if (value == 0) {
        return "—";
      } else {
        return this.formatter.format(value / 100);
      }
    },
    pageUpDrivers: function () {
      if (this.driverPagination.page < this.invoicesSummary.num_pages) {
        this.$emit(
          "getInvoices",
          this.driverPagination.page * this.invoicesSummaryRows
        );
        this.driverPagination.page++;
      }
    },
    pageDownDrivers: function () {
      if (this.driverPagination.page > 1) {
        this.$emit(
          "getInvoices",
          (this.driverPagination.page - 2) * this.invoicesSummaryRows
        );
        this.driverPagination.page--;
      }
    },
    loadInvoice: function (invoiceID, driver) {
      console.log("Load invoice");
      console.log(driver);
      if (invoiceID != this.selectedInvoiceID) {
        this.selectedInvoiceID = invoiceID;
        let payload = {
          invoiceID: invoiceID,
          driver: driver,
        };
        this.$emit("loadInvoice", payload);
      } else {
        this.selectedInvoiceID = -1;
        this.$emit("closeInvoice");
      }
    },
    goToDriver: function (driverID) {
      let routeData = this.$router.resolve(`/invoices/driver/${driverID}`);
      window.open(routeData.href, "_blank");
    },
    searchDrivers: function () {
      this.driverPagination.page = 1;
      this.$emit("search");
    },
    getPayableColour: function (invoiceID, payable) {
      // if (this.selectedInvoiceID == invoiceID) {
      //   if (payable < 0) {
      //     return "yellow--text";
      //   } else {
      //     return "white--text";
      //   }
      // } else {
      if (payable < 0) {
        return "red--text";
      } else {
        return "green--text text--darken-2";
      }
      // }
    },
    calculateRowStyling: function (invoice) {
      let style = {};
      if (invoice.id == this.selectedInvoiceID) {
        style["background-color"] = "#E0E0E0";
      }
      return style;
    },
  },
};
</script>

<style scoped lang="scss">
.nobold {
  font-weight: normal;
}

.v-data-table td {
  font-size: 14px;
  height: 19px;
}

table.v-table tbody tr td {
  height: 19px;
}

table.v-table tbody tr td a {
  text-decoration: none;
}

.embeddedInvoiceTable {
  max-height: calc(299px);
  overflow-y: auto;
}

.shadowRow {
  -moz-box-shadow: inset 4px 0px 3px -1px #999;
  -webkit-box-shadow: inset 4px 0px 3px -1px #999;
  box-shadow: inset 4px 0px 3px -1px #999;
}

.invoiceHeader {
  height: 15px;
}

.invoiceFooter {
  height: 20px;
}

.driverTable {
  min-height: calc(50vh - 48px - 28px - 6px);
  max-height: calc(50vh - 48px - 28px - 6px);
  overflow-y: auto;
}

.driverHeader {
  height: 30px;
}

.fixedTableFooter {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.driverFooter {
  height: 30px;
  width: "100%";
}

.removeButtonPadding {
  min-width: 0;
  padding-right: 3px;
  padding-left: 3px;
  margin: 0;
  border-radius: 0;
  height: 20px;
}

.smallSearch {
  transform: scale(0.75);
  transform-origin: left;
}

.scroll-wrapper {
  height: 95vh;
  overflow-y: scroll;
  width: 100%;
}

.v-expansion-panel-header {
  padding: 12px 12px !important;
}

.col {
  padding: 0px !important;
}

.v-list-item {
  padding: 0 0px;
}

.v-list-item__content {
  padding: 0px 0;
}

.v-list {
  padding: 0px 0;
}

::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }

  .shadowRow[data-v-f3a77322] {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .v-expansion-panel--active:not(:first-child) {
    margin-top: 2px !important;
  }

  .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 3px !important;
  }
}
</style>
